<template>
	<!-- IMPORTANT: parent container nedds to have d-flex class -->
	<div class="vue-crop-map map" style="z-index: 1; min-height: 400px">
		<l-map
			ref="lmap"
			style="height: 100%; width: 100%"
			:zoom="zoom"
			v-bind:min-zoom="4"
			:max-zoom="maxZoom"
			:center="center"
			@update:zoom="zoomUpdated"
			@update:center="centerUpdated"
			@update:bounds="boundsUpdated"
			:draggable="false"
		>
			<l-tile-layer
				:options="{ tileSize: 512, zoomOffset: -1 }"
				:url="url"
				:attribution="attribution"
			></l-tile-layer>
			<l-feature-group ref="fg">
				<v-marker-cluster
					ref="cluster"
					:averageCenter="true"
					:ignoreHidden="true"
					:options="clusterOptions"
				>
					<component
						v-if="markers"
						v-bind:is="markerComponent"
						v-for="(marker, idx) in markers"
						:active-id="activeId"
						:state="state"
						:item="marker"
						:key="'map-marker-' + idx"
					/>
					<slot />
				</v-marker-cluster>
			</l-feature-group>

			<slot name="other" />
		</l-map>
	</div>
</template>

<script>
import {
	LMap,
	LTileLayer,
	LFeatureGroup,
	LMarker,
	LPopup,
	LIcon,
} from "vue2-leaflet";

import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";

import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
	iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
	iconUrl: require("leaflet/dist/images/marker-icon.png"),
	shadowUrl: null,
	iconSize: [40, 40],
});

export default {
	components: {
		LMap,
		LTileLayer,
		LFeatureGroup,
		LMarker,
		LPopup,
		LIcon,
		"v-marker-cluster": Vue2LeafletMarkerCluster,
	},
	props: {
		maxZoom: {
			type: Number,
			default: 10,
		},
		initialZoom: {
			type: Number,
			default: 7,
		},
		initialCenter: {
			type: Array,
		},
		markers: {
			type: Array,
			required: false,
		},
		markerComponent: {
			type: String,
			required: false,
			default: "searchResultsMapMarker",
		},
		activeId: {
			type: String,
			required: false,
		},
		state: {
			type: Object,
			required: false,
			default: () => {},
		},
		shouldFitBounds: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		let mapId = {
				de: "cropspot/ckng1992d4b5o17p3xyyitg8a",
				en: "cropspot/ckuwdkoku0l9318rp9cf4r6yi",
			},
			mapMeta = this.$inertia.page.props.mapMeta,
			defaultCenter = [51.5497446, 8.57347496821343];

		if (mapMeta.center && mapMeta.center.coordinates) {
			defaultCenter = [
				mapMeta.center.coordinates[1],
				mapMeta.center.coordinates[0],
			];
		}
		console.log(mapMeta, defaultCenter, this.initialCenter || defaultCenter);

		return {
			zoom: this.initialZoom,
			center: this.initialCenter || defaultCenter,
			url:
				"https://api.mapbox.com/styles/v1/" +
				mapId[this.locale] +
				"/tiles/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiY3JvcHNwb3QiLCJhIjoiY2tuZTl5b2I5MjNpZjJ5dGE4NDZra2ozdiJ9.HZThhcRT-kVrBKsbrlfRGg",
			bounds: null,
			attribution:
				'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors,  Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
			clusterOptions: {
				disableClusteringAtZoom: 5,
				spiderfyDistanceMultiplier: 5,
			},
		};
	},
	methods: {
		zoomUpdated(zoom) {
			this.zoom = zoom;
		},
		centerUpdated(center) {
			this.center = center;
		},
		boundsUpdated(bounds) {
			console.log("bounds updated!", bounds);
			this.bounds = bounds;
		},
		fitBounds() {
			if (this.shouldFitBounds) {
				this.$nextTick(() => {
					if (this.$refs.fg) {
						let newBounds = this.$refs.fg.mapObject.getBounds();
						this.$refs.lmap.mapObject.fitBounds(newBounds);
					}
				});
			}
		},
	},
	mounted() {
		this.fitBounds();
	},
	watch: {
		markers: {
			handler() {
				this.fitBounds();
			},
			deep: true,
			immediate: true,
		},
	},
	computed: {
		mapObject() {
			return this.$refs.lmap.mapObject;
		},
	},
};
</script>

<style scoped>
@import "~leaflet.markercluster/dist/MarkerCluster.css";

.cluster {
	position: absolute;
	margin-left: -20px;
	margin-top: -20px;
}
</style>
